import AddNewClient from '../pages/clients/AddNewClient'
import Client from '../pages/clients/ClientPage/Client'
import Clients from '../pages/clients/Clients'
import PendingClientAccounts from '../pages/clients/PendingClientAccounts'
import QuoteBuilder from '../pages/events/planning/Quotes/QuoteBuilder/QuoteBuilder'

export default [
  { path: '/clients', element: <Clients />, title: 'Clients' },
  { path: '/clients/new', element: <AddNewClient />, title: 'New Client' },
  { path: '/clients/:id', element: <Client /> },
  { path: '/clients/newquote', element: <QuoteBuilder />, title: 'New Quote' },
  { path: '/pending-client-accounts', element: <PendingClientAccounts />, title: 'Client Accounts' },
]
